export default "__VITE_ASSET__Dv8Rw9st__"